<!-- 创建商家券模板并售卖商家券给商户接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "carCode": "粤B88888",
                "parkCode": "2KKN6111",
                "couponCode": "123456",
                "reliefValue": 5.00,
                "usedUsePhone": "13800138000",
                "usedUserWeixinId": "oS2eTwwc0DN55MMqcOTVy433S68U",
                "billCode": "2018070513481555662867",
                "thirdBillCode": "4200000110201807178442249929",
                "payTime": "2018-07-31 11:14:39",
                "payMode": 4,
                "payModeRemark": "通联",
                "payOrigin": 7,
                "payOriginRemark": "智慧停车",
            },
            responseCode: {
                "data": {},
                "message": "ok",
                "resultCode": 0,
                "status": 1
            },
            infoData: {
                explain: "智慧停车使用第三方优惠券后，主动将使用信息通知第三方",
                urlPattern: this.commonUrls.third+"thirdCouponUse",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "第三方提供接口, 智慧停车开放平台主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '车场编码' },
                        { info1: 'carCode', info2: '是', info3: 'String', info4: '车牌' },
                        { info1: 'couponCode', info2: '是', info3: 'String', info4: '优惠券编码' },
                        { info1: 'reliefValue', info2: '是', info3: 'String', info4: '抵扣金额' },
                        { info1: 'usedUserPhone', info2: '否', info3: 'String', info4: '使用人手机号' },
                        { info1: 'usedUserWeixinId', info2: '否', info3: 'String', info4: '使用人微信OPEN_ID' },
                        { info1: 'billCode', info2: '是', info3: 'String', info4: '订单号' },
                        { info1: 'thirdBillCode', info2: '是', info3: 'String', info4: '第三方订单号' },
                        { info1: 'payTime', info2: '是', info3: 'String', info4: '支付时间 yyyy-MM-dd HH:mm:ss' },
                        { info1: 'payMode', info2: '是', info3: 'String', info4: '支付方式(请<url>参考附录:/Api/appendixData#appendixData_0</url>)' },
                        { info1: 'payModeRemark', info2: '是', info3: 'String', info4: '支付方式备注' },
                        { info1: 'payOrigin', info2: '是', info3: 'String', info4: '支付来源(请<url>参考附录:/Api/appendixData#appendixData_1</url>)' },
                        { info1: 'payOriginRemark', info2: '是', info3: 'String', info4: '支付来源备注' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [

                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/preferential/thirdCoupon/thirdCouponUse.vue